import {
    AUTH_ERROR_ACTION,
    NOTIFIED_ACTION
} from './constants';

const initialState = {
    error: false
};

const authReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case AUTH_ERROR_ACTION:
            return {
                error: true
            };
        case NOTIFIED_ACTION:
            return {
                error: false
            };
        default:
            return state;
    }
};

export default authReducer;
